import api from '@/common/api.js'

export default {
  namespaced: true,

  state: {
    items: null
  },

  getters: {
    items: (state) => state.items
  },

  actions: {
    async fetchFromApi ({ commit }) {
      try {
        const response = await api.get('os/tipos')

        commit('setItems', response.data.items)
        return response
      } catch (error) {
        throw new Error(error)
      }
    },
    async getOsLancada( { state, commit }, { data } ){
      try{
        const response = await api.get(`os/novaOs/${data.nr_problema}/getOsLancada/${data.nr_segmento}/${data.placa}`, { ...data })

        return response.data.osExistente
      } catch (error) {
        throw new Error(error)
      }
    }
  },

  mutations: {
    setItems (state, items) {
      if (Array.isArray(items)) {
        state.items = items.map(item => {
          if (item.nr_sequencial === 'V' && (item.ds_tipo === 'PREVENTIVA CAVALO' || !item.ds_tipo)) {
            return { ...item, ds_tipo: 'PREVENTIVA' }
          }
          if (item.nr_sequencial === 'R' && (!item.ds_tipo || item.ds_tipo === 'PREV CARROCERIA')) {
            return { ...item, ds_tipo: 'PREVENTIVA CARROCERIA' }
          }
          return item
        })
      } else {
        state.items = items
      }
    }
  }
}
